import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        rolesForm: '='
    },
    template: `
        <div class="desktop-hide">
            <dl class="type01" ng-repeat="(role, label) in vm.EVALUATION_ROLE_ENUM.LABELS">
                <dt>{{ label }}</dt>
                <dd>
                    {{ vm.rolesForm.roles[role].actual ? vm.rolesForm.roles[role].actual : 0 }}/
                    {{ vm.rolesForm.roles[role].anticipated ? vm.rolesForm.roles[role].anticipated : 0 }}
                     <small>({{ vm.rolesForm.roles[role].percentage ? vm.rolesForm.roles[role].percentage : 0 }}%)</small>
                </dd>
            </dl>
        </div>
    `
})
export default class {
    constructor (EVALUATION_ROLE_ENUM) {
        this.EVALUATION_ROLE_ENUM = EVALUATION_ROLE_ENUM;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/role/mobile/index.js